export default "__VITE_ASSET__B6gZcdAr__"